import { useQuery } from "@tanstack/react-query";
import { getReportsHistory } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useReportsHistory(options = {}) {
  const { enabled = true } = options;

  const queryKey = ["reportsHistory"];

  const { data, error, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: async () => {
      try {
        const res = await getReportsHistory();
        return res;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    enabled,
    staleTime: 1000 * 60 * 30, 
    cacheTime: 1000 * 60 * 60 * 12, 
    refetchOnWindowFocus: false,
  });

  const reports = data?.data?.history ?? [];
  const totalCount = data?.data?.total_count ?? 0;
  const meta = data?.meta ?? null;

  return {
    reports,
    totalCount,
    meta,
    error,
    isLoading,
    reload: refetch,
  };
}























































